import { gql } from '@apollo/client';

export const FETCH_USER_TRACKING = gql`
  query fetchUserTracking {
    getUserTrackingData {
      dailyStreak
      streakRecord
      emotionsTracked
    }
  }
`;

export const FETCH_USER_TRACKING_RANGE = gql`
  query fetchLoginTracker($startDay: Date!, $endDay: Date!, $userId: ID!) {
    loginTrackers(filters: { day: { gte: $startDay, lte: $endDay }, user: { id: { eq: $userId } } }) {
      data {
        attributes {
          streakCounter
          day
        }
      }
    }
  }
`;
